export default "__VITE_ASSET__366b6788__"